import axios, { AxiosError } from 'axios';
import { SELF_SERVICE_API_URL } from 'config';
import type { SelfServiceAPI } from 'types';
import handleServiceError from '../utils/handleServiceError';

interface Params {
  bookingId: string;
  amendmentId: string;
}

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
}

const getAmendment = async ({ bookingId, amendmentId }: Params, options: Options = {}): Promise<SelfServiceAPI.GetAmendment.Response> => {
  try {
    const { data } = await axios.get<SelfServiceAPI.GetAmendment.Response>(
      `${SELF_SERVICE_API_URL}/bookings/${bookingId}/amendments/${amendmentId}`,
      {
        withCredentials: true,
      },
    );

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await getAmendment({ bookingId, amendmentId }, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `GET /bookings/${bookingId}/amendments/${amendmentId}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getAmendment;
